<div style="padding-left: 50px;">
  <div class="back-button" *ngIf="this.controlItemIdFromRoute">
    <button mat-raised-button
            style="border-radius: 6px;margin-right: 10px;white-space: nowrap; "
            class="button" (click)="backToProject()">
      <i class="pi pi-arrow-left" style="margin-right: 0.5em; font-size: 0.75em;"></i>
      Back to project
    </button>
  </div>

  <div class="row wrap">
    <div class="col-md-3" *ngFor="let ws of workstreams">
      <div class="box box-info">
        <div class="box-header with-border">
          <h4 class="box-title">{{ ws.name }}</h4>
        </div>

        <div class="box-body">
          <div class="subtexts-row">
            <div class="subtext-box"
                 [class.filterSelected]="(isFilterSelected || this.controlItemIdFromRoute) && !isSelected(ws.workstreamId, 'Outstanding')"
                 [class.itemSelected]="isSelected(ws.workstreamId, 'Outstanding')"
                 (click)="handleClickOnWorkstreamFilter(ws.workstreamId, 'Outstanding')">
              <div class="subtext-title">Outstanding</div>
              <div class="subtext-value">{{ ws.outstandingItemsCount }}</div>
            </div>
            <div class="subtext-box"
                 [class.filterSelected]="(isFilterSelected || this.controlItemIdFromRoute) && !isSelected(ws.workstreamId, 'Overdue')"
                 [class.itemSelected]="isSelected(ws.workstreamId, 'Overdue')"
                 (click)="handleClickOnWorkstreamFilter(ws.workstreamId, 'Overdue')">
              <div class="subtext-title">Overdue</div>
              <div class="subtext-value">{{ ws.overdueItemsCount }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>


  <div class="actions">
    <button *ngIf="!this.controlItemIdFromRoute" mat-raised-button
            style="border-radius: 6px; margin: 10px;" (click)="!isFilterSelected && getAllOverdueItems()">
      All Overdue Workspace Items
    </button>
    <button mat-raised-button [matMenuTriggerFor]="appMenu"
            style="border-radius: 6px;margin-right: 10px;white-space: nowrap; "
            class="button">
      Actions<span class="mat-select-arrow"
                   style="display:inline-block; width: 0;height: 0;border-left: 5px solid transparent;border-right: 5px solid transparent;border-top: 5px solid;margin: 0 4px;"></span>
    </button>
    <mat-menu #appMenu="matMenu">
      <button mat-menu-item
              type="button"
              (click)="createWorkstream()">
        Add Workstream
      </button>
      <button mat-menu-item
              type="button"
              (click)="importWorkstream()">
        Import Workstream
      </button>
      <button mat-menu-item
              type="button"
              (click)="table.exportCSV()">
        Export CSV
      </button>
    </mat-menu>
  </div>

  <p-table [columns]="exportCols"
           [value]="filteredWorkstream"
           [style]="{'margin-top':'10px', 'font-size' : '1.5em'}"
           dataKey="workstreamId"
           [resizableColumns]="true"
           (onRowReorder)="saveWorkStreamOrder($event)"
           [expandedRowKeys]="expandedWorkstreams"
           #table
           class="ptable">
    <ng-template pTemplate="caption">
      <div class="ui-helper-clearfix" style="display: flex;">
        <div style="flex: 0 0 auto; width:25%">
          <p-multiSelect [defaultLabel]="'Select Columns'" [options]="columnOptions"
                         [(ngModel)]="cols"
                         (onChange)="onPanelHide()" [style]="{'width':'300px'}">
            <ng-template let-selectedItem pTemplate="selectedItems">
              Select Columns
            </ng-template>
          </p-multiSelect>
        </div>
      </div>
    </ng-template>

    <ng-template pTemplate="header">
      <tr style="white-space: nowrap;font-weight: bold">
        <th style="width: 8em;"></th>
        <th style="text-align: left;">Workstream</th>
        <th style="padding: 0; width: 10em;">

          <button mat-raised-button color="primary"
                  style="border-radius: 20px; display: flex; margin-right: 1em; height: 4.5em; margin-bottom: 1em;"
                  *ngIf="this.controlItemIdFromRoute" (click)="clearFilter()">
            <i class="pi pi-times" style="margin-right: 0.5em; font-size: 0.75em;"></i>
            Control: {{ complianceAreaControlIdFromFilter }}
          </button>

          <button mat-raised-button color="primary"
                  style="border-radius: 20px; display: flex; margin-right: 1em; margin-bottom: 1em;"
                  *ngIf="this.isFilterSelected" (click)="clearFilter()">
            <i class="pi pi-times" style="margin-right: 0.5em; font-size: 0.75em;"></i>
            Clear Filter
          </button>
        </th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-item let-rowIndex="rowIndex" let-expanded="expanded">
      <tr [pReorderableRow]="rowIndex" class="ui-widget-header" pDroppable (onDrop)="onWorkstreamChange(item, $event)">
        <td colspan="2">
          <a href="#" [pRowToggler]="item" (click)="toggleExpandedWorkstream(item.workstreamId)">
            <i [ngClass]="expanded ? 'fa fa-fw fa-chevron-circle-down' : 'fa fa-fw fa-chevron-circle-right'"></i>
            <span>{{ item.name }}</span>
          </a>
        </td>
        <td>
          <button type="button"
                  pButton
                  class="risksponge-button"
                  (click)="editWorkstream(item)"
                  icon="pi pi-pencil">
          </button>
          <button type="button"
                  pButton
                  class="risksponge-button"
                  (click)="deleteWorkstream(item)"
                  icon="pi pi-times">
          </button>
          <button type="button"
                  pButton
                  class="risksponge-button"
                  (click)="duplicateWorkstream(item)"
                  icon="pi pi-copy">
          </button>
          <button type="button"
                  pButton
                  class="risksponge-button"
                  (click)="createWorkstreamItem(item)"
                  icon="pi pi-plus">
          </button>
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="expandedrow" let-workstream>
      <tr>
        <td style="padding-left: 50px;" colspan="3">
          <p-table [columns]="cols"
                   [value]="workstream.workstreamItems"
                   [style]="{'margin-top':'10px', 'font-size' : '1em'}"
                   dataKey="type"
                   [resizableColumns]="true"
                   [expandedRowKeys]="expandedWorkstreamItems"
                   #table>
            <ng-template pTemplate="header">
              <tr style="white-space: nowrap;">
                <th style="width:5em"></th>
                <th *ngFor="let col of cols" pResizableColumn>{{ col.header }}</th>
                <th style="width:8em"></th>
              </tr>
              <tr>
                <th></th>
                <th *ngFor="let col of cols">
                  <input pInputText type="text" placeholder="⌕"
                         (input)="table.filter($event.target['value'], col.field, 'contains')"/>
                </th>
                <th></th>
              </tr>
            </ng-template>

            <ng-template pTemplate="body" let-item let-rowIndex="rowIndex" let-expanded="expanded">
              <tr class="ui-widget-header"
                  *ngIf="rowGroupMetadata[workstream.workstreamId][item.workstreamItemId] === item.workstreamItemId">
                <td [attr.colspan]="cols.length + 1">
                  <a href="#" [pRowToggler]="item">
                    <i
                      [ngClass]="expanded ? 'fa fa-fw fa-chevron-circle-down' : 'fa fa-fw fa-chevron-circle-right'"></i>
                    <span>{{ item.type }}</span>
                  </a>
                </td>
              </tr>
            </ng-template>

            <ng-template pTemplate="expandedrow" let-item let-rowIndex="rowIndex">
              <tr pDraggable dragHandle=".pi-bars" (onDragStart)="this.draggedItem = item">
                <td>
                  <span class="pi pi-bars"></span>
                </td>
                <td *ngFor="let col of cols">
                  <div style="overflow-x: hidden;text-overflow: ellipsis;white-space: nowrap;"
                       title="{{item[col.field]}}">{{ col.fn && item[col.field] ? col.fn(item[col.field]) : item[col.field] }}
                  </div>
                </td>
                <td style="width: 5em;">
                  <button type="button"
                          pButton
                          class="risksponge-button"
                          (click)="editWorkstreamItem(item)"
                          icon="pi pi-pencil">
                  </button>
                  <button type="button"
                          pButton
                          class="risksponge-button"
                          (click)="deleteWorkstreamItem(item)"
                          icon="pi pi-times">
                  </button>
                  <button type="button"
                          pButton
                          class="risksponge-button"
                          (click)="duplicateWorkstreamItem(item)"
                          icon="pi pi-copy">
                  </button>
                </td>
              </tr>
              <tr *ngIf="item.virtual">
                <td [attr.colspan]="cols.length + 1">No items</td>
              </tr>
            </ng-template>
          </p-table>
        </td>
      </tr>
    </ng-template>

  </p-table>
</div>
